import React from "react";

const CenterHeading = ({ title }) => {
  return <div className="font-bold underline text-center mt-3">{title}</div>;
};

export default CenterHeading;
